import axios from "../axiosPlugin.js";

const _GOODS_PACKAGE_API = "/api/goodsPackage";

export const getGoodsPackageListService = data => {
  return axios({
    url: `${_GOODS_PACKAGE_API}/list`,
    method: "get",
    data: { data },
  });
};

export const getGoodsPackageDetailService = data => {
  return axios({
    url: `${_GOODS_PACKAGE_API}/detail/${data.id}`,
    method: "get",
    data: {
      data,
    },
  });
};

export const addGoodsPackageService = data => {
  return axios({
    url: `${_GOODS_PACKAGE_API}/create`,
    method: "post",
    data: {
      data,
    },
  });
};

export const updateGoodsPackageService = data => {
  return axios({
    url: `${_GOODS_PACKAGE_API}/update`,
    method: "put",
    data: {
      data,
    },
  });
};

export const delGoodsPackageService = data => {
  return axios({
    url: `${_GOODS_PACKAGE_API}/delete/${data.id}`,
    method: "delete",
    data: {
      data,
    },
  });
};

export const approveGoodsPackageService = data => {
  return axios({
    url: `${_GOODS_PACKAGE_API}/approve?cinemaId=${data.cinemaId}`,
    method: "post",
    data: {
      data,
    },
  });
};
